// useDownloadTemplate.js
import { useState } from "react";
import { downloadFileBase64 } from "../../../../../utils/utils";
import { getDateTime } from "../../../../Queries/components/utils";
import { appName, formatDateForExcelHeader } from "../../../../../utils/excelUtils";

export const TEMPLATE_COLUMNS = [
  { key: "code", title: "Código" },
  { key: "collaborator", title: "Colaborador" },
  { key: "description", title: "Descripción" },
  { key: "admissionDate", title: "Fecha registro" },
  { key: "vacationDaysAccrued", title: "Días vacaciones abonados" },
  { key: "vacationDaysTaken", title: "Días vacaciones tomados" },

  // TODO: descomentar si se reactiva la captura de prima vacacional en la plantilla.
  // { key: "vacationPremiumPct", title: "% Prima vacacional" },
  // { key: "vacationPremiumDays", title: "Días prima vacacional" },
];

const processCollaborators = (collaborators, sort = []) => {
  const sorted = sort.length
    ? [...collaborators].sort((a, b) => {
      const { field, order } = sort[0];
      const valA = a[field] ?? "";
      const valB = b[field] ?? "";

      if (typeof valA === "string" && typeof valB === "string") {
        return order === 1
          ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: "base" })
          : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: "base" });
      }

      return order === 1 ? (valA < valB ? -1 : 1) : (valA > valB ? -1 : 1);
    })
    : [...collaborators];

  return sorted.map((c) => ({
    code: { value: c.code, style: { horizontalAlignment: "center", numberFormat: "@" } },
    collaborator: { value: c.fullName, style: { horizontalAlignment: "left" } },
    description: { value: "", style: {} },
    admissionDate: { value: "", style: {} },
    vacationDaysAccrued: { value: "", style: {} },
    vacationDaysTaken: { value: "", style: {} },

    // TODO: descomentar si se reactiva la captura de prima vacacional en la plantilla.
    // vacationPremiumPct: { value: "", style: {} },
    // vacationPremiumDays: { value: "", style: {} },
  }));
};

export const useDownloadTemplate = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTemplate = async ({ collaborators = [], sort = [] }) => {
    try {
      setIsDownloading(true);
      const toExcel = {
        filename: "Saldo vacaciones",
        templateFileName: "balance_template.xlsx",
        replace: [
          { type: 0, tag: "#simple.name", prop: "name", default: "", },
          { type: 1, tag: "#printDate", prop: "printDate", default: new Date().toLocaleDateString(), format: ["numberFormat", "dd mmmm yyyy"] },
          { type: 2, tag: "#simple.cols", prop: "cols" },
          { type: 4, tag: "#simple.rows", prop: "rows", colprop: "cols", default: "N/D" },
        ],
        data: {
          company: "",
          autoFilter: true,
          gridLinesVisible: true,
          printDate: formatDateForExcelHeader(new Date()),
          appName: appName,
          name: "Plantilla de saldos",
          cols: TEMPLATE_COLUMNS.map(({ key, title }) => ({
            title,
            prop: key,
            width: title.length + 20,
          })),
          rows: processCollaborators(collaborators, sort),
        },
      };

      const dateName = getDateTime();
      await downloadFileBase64(toExcel, "xlsx", `Saldo Vacaciones_${dateName}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadTemplate, isDownloading };
};